var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-button-wrapper" },
    _vm._l(_vm.views, function (view) {
      return _c("div", { key: view, staticClass: "view-button-item" }, [
        _c("div", {
          staticClass: "fa view-button-item-button",
          class: [
            _vm.activeView === view ? "active" : "",
            view === "grid" ? "fa-table" : "fa-bars",
          ],
          on: {
            click: function ($event) {
              return _vm.setView(view)
            },
          },
        }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }